import { gql } from "graphql-tag"

const news = gql`
  input NewsAddInput {
    "IMDb Id"
    IMDbId: ID
    "Additional Instructions"
    additionalInstructions: String
    "Author Id"
    authorId: ID!
    "Home Video Id"
    homeVideoId: ID
    "Images"
    images: [ImageAddInput]
    "Screenshots"
    screenshots: [ScreenshotAddInput]
    "Add Home Video?"
    isAddHomeVideo: Boolean!
    "Is it a Blu Ray"
    isBluRay: Boolean
    "Is it Published"
    isPublished: Boolean!
    "Is it UHD"
    isUHD: Boolean
    "Name"
    name: String
    "Release Date"
    releaseDate: String
    "Slug"
    slug: String
    "Sources Ids"
    sourcesIds: [String]
    "Text"
    text: String
  }

  type NewsAddResponse {
    "Status"
    status: String!
  }

  input GenerateDraftNewsInputOptions {
    "Add to Queue?"
    isAddToQueue: Boolean
  }

  input GenerateDraftNewsInput {
    "Additional Instructions"
    additionalInstructions: String
    "News Id"
    id: ID!
  }

  type GenerateDraftNewsResponse {
    "IDs"
    ids: [ID!]!
  }

  input PublishDraftNewsInputOptions {
    "Add to Queue?"
    isAddToQueue: Boolean
    "Generate News?"
    isGenerate: Boolean
  }

  input PublishDraftNewsInput {
    "Additional Instructions"
    additionalInstructions: String
    "News Id"
    id: ID!
  }

  type PublishDraftNewsResponse {
    "IDs"
    ids: [ID!]!
  }

  input NewsUpdateInputOptions {
    "Add to Queue?"
    isAddToQueue: Boolean
    "Generate News?"
    isGenerate: Boolean
  }

  input NewsUpdateInput {
    "IMDb Id"
    IMDbId: ID
    "Additional Instructions"
    additionalInstructions: String
    "Autor Id"
    authorId: ID
    "Home Video Id"
    homeVideoId: ID
    "Images"
    images: [ImageUpdateInput]
    "Screenshots"
    screenshots: [ScreenshotUpdateInput]
    "ID"
    id: ID!
    "Is Add Home Video?"
    isAddHomeVideo: Boolean
    "Is it a Blu Ray"
    isBluRay: Boolean
    "Is it Published"
    isPublished: Boolean
    "Is it UHD"
    isUHD: Boolean
    "Name"
    name: String
    "Release Date"
    releaseDate: String
    "Slug"
    slug: String
    "Sources Ids"
    sourcesIds: [String]
    "Subheading"
    subheading: String
    "Text"
    text: String
  }

  type NewsUpdateResponse {
    "News Id"
    id: ID!
  }

  type News {
    "Author"
    author: ContentAuthor
    "Created At"
    createdAt: String!
    "Home Video"
    homeVideo: HomeVideo
    "Id"
    id: ID!
    "Images"
    images: [Image]
    "Is Published?"
    isPublished: Boolean!
    "Name"
    name: String!
    "Published At"
    publishedAt: String
    "Slug"
    slug: String!
    "News Sources"
    sources: [NewsSource]
    "Subheading"
    subheading: String!
    "Text"
    text: String!
    "Updated At"
    updatedAt: String!
  }

  type NewsWave {
    cursor: String
    hasPrevData: Boolean
    hasNextData: Boolean!
    news: [News]!
    prevCursor: String
  }

  input SearchNewsInput {
    name: String
  }
`

export default news
